var _circle, _rect, _rect2, _path, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcNoOffer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 186,
    viewBox: "0 0 144 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71.8414,
    cy: 72.4585,
    r: 71.5,
    fill: "#F1F1F1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 43.7919,
    y: 71.0012,
    width: 70,
    height: 98,
    rx: 7,
    transform: "rotate(2.5 43.7919 71.0012)",
    fill: "#EEEEEE",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.17728,
    y: 65.1392,
    width: 74,
    height: 102,
    rx: 9,
    transform: "rotate(-7.5 2.17728 65.1392)",
    fill: "#FAFAFA",
    stroke: "#999999",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34346 73.9316C3.76676 69.5512 6.85034 65.5326 11.2308 64.9559L66.7517 57.6464C71.1322 57.0697 75.1508 60.1533 75.7275 64.5338L77.6854 79.4054L6.30136 88.8033L4.34346 73.9316Z",
    fill: "#EEEEEE"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 90.2076,
    y: 59.6015,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(82.5 90.2076 59.6015)",
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62.8109,
    y: 43.0358,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(-7.5 62.8109 43.0358)",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 80.3886,
    y: 45.7648,
    width: 3,
    height: 10,
    rx: 1.5,
    transform: "rotate(37.5 80.3886 45.7648)",
    fill: "#999999"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 13.7636,
    y: 91.8554,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 13.7636 91.8554)",
    fill: "#DCDCDC"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16.3741,
    y: 111.684,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 16.3741 111.684)",
    fill: "#DCDCDC"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 18.9846,
    y: 131.513,
    width: 58,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 18.9846 131.513)",
    fill: "#DCDCDC"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 14.8078,
    y: 99.787,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 14.8078 99.787)",
    fill: "#EEEEEE"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.4183,
    y: 119.616,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 17.4183 119.616)",
    fill: "#EEEEEE"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 20.0288,
    y: 139.445,
    width: 21,
    height: 4,
    rx: 2,
    transform: "rotate(-7.5 20.0288 139.445)",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNoOffer);
export default __webpack_public_path__ + "static/media/ic_no_offer.ffe83502f9a5ff8f3fb5182d5659fca0.svg";
export { ForwardRef as ReactComponent };